import { render, staticRenderFns } from "./KoIKOTable.vue?vue&type=template&id=57d6385a"
import script from "./KoIKOTable.vue?vue&type=script&lang=js"
export * from "./KoIKOTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports